import React from 'react'
import {DatePollInfo} from "../../models/DatePollInfo";
import {WhiteBox} from "./WhiteBox";
import {Box, Grid} from "@mui/material";
import {BestDateItem} from "./BestDateItem";
import FavoriteIcon from '@mui/icons-material/Favorite';
import {HILIGHT_COLOR} from "../../constants/constants";

interface BestDatesBoardProps {
    datePollInfos: DatePollInfo[];
}

export const BestDatesBoard: React.FC<BestDatesBoardProps> = ({ datePollInfos }) => {
    return (
        <WhiteBox>
            <span>날짜 선정 현황</span>
            <Box height={'10px'} />
            <span className={"description-text"}>만날 가능성이 높은 날짜 순으로 보여줘요</span>
            <Box height={'18px'} />
            <Grid container spacing={1}>
                {/* TODO 기획서처럼 아이콘 정렬 변경 필요함 */}
                <Grid item xs={'auto'}>
                    <FavoriteIcon sx={{color: HILIGHT_COLOR}} />
                </Grid>
                <Grid container item direction={'column'} spacing={1} xs>
                    <Grid item>
                        <span className={"highlight-text"}>확실히 되는 날 TOP 3</span>
                    </Grid>
                    <Grid container item direction={'column'} spacing={1.5}>
                        {datePollInfos.map((datePollInfo, index) => (
                            <Grid item key={index}>
                                <BestDateItem datePollInfo={datePollInfo} />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </WhiteBox>
    )
}